import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { msalInstance } from './config/msalConfig';
import api from './services/api';

msalInstance.initialize().then(async () => {
  try {
    const response = await msalInstance.handleRedirectPromise();
    if (response?.idToken) {
      const res = await api.post('/auth/microsoft', { idToken: response.idToken });
      if (res.status === 200) {
        localStorage.setItem('token', res.data.token);
        localStorage.setItem('user', JSON.stringify(res.data.user));
        window.location.replace('/dashboard');
        return;
      }
    }
  } catch (e) {
    const errorMsg = e.response?.data?.error || e.message;
    if (errorMsg && e.response?.status) {
      localStorage.setItem('microsoftLoginError', errorMsg);
    }
  }

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});

reportWebVitals();